<template>
  <div class="seo-content">
    <div class="item" v-for="item of list" :key="item.id">
      <template v-if="item.attributes">
        <h1 class="title">{{ item.attributes.title }}</h1>
        <div class="content" v-html="item.attributes.content"></div>
        <div class="more" @click="toDetail(item.attributes.title)">
          <button>More Details</button>
          <i class="el-icon-right"></i>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BlogList',
  props: {},
  data() {
    return {
      list: []
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await fetch('https://strapi.nicee.tw/api/posts/');
      const { data } = await res.json();
      this.list = data;
    },
    toDetail(title) {
      const url = encodeURI(`${location.href}/${title}`);
      window.open(`${url}`, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.seo-content {
  padding-top: 130px;
  overflow: auto;
  @include hideScrollBar(0, 0);
}
.item {
  margin-bottom: 40px;
  color: #808080;
  font-size: 18px;
  //   width: 100%;
  > .title {
    font-size: 23px;
    color: #222222;
    font-weight: 700;
  }
  > .content {
    margin-top: 20px;
    position: relative;
    line-height: 31px;
    max-height: 140px;
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 30px;
      background: linear-gradient(to bottom, rgba(249, 249, 249, 0.5), #f9f9f9);
    }
  }
  .more {
    display: flex;
    align-items: center;
    color: $color-yellow;
    padding-top: 20px;
    cursor: pointer;
    > button {
      color: $color-yellow;
    }
  }
}
</style>
